import React from 'react';
import Typography from '@material-ui/core/Typography';
import {withStyles} from '@material-ui/core/styles';


function DescriptionItem(props) {
  const {classes, term, details, operator, spaceBefore} = props;

  return (
    <div className={`${classes.container} ${spaceBefore && classes.spaceBefore}`}>
      <Typography variant={'body2'} className={classes.term}>{term}</Typography>
      <Typography variant={'body2'} className={classes.mathSymbol}>{operator}</Typography>
      <Typography variant={'body2'} className={classes.details}>{details}</Typography>
    </div>
  )
}

const diStyles = (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    minHeight: theme.spacing.unit * 2,
  },
  term: {
    flex: 1,
    lineHeight: '2em',
  },
  mathSymbol: {
    flex: 0.1,
    lineHeight: '2em',
    color: '#999999',
  },
  details: {
    flex: 2,
    whiteSpace: 'pre-line',
    justifyContent: 'flex-end',
    lineHeight: '2em',
  },
  spaceBefore: {
    marginTop: theme.spacing.unit * 2,
  },
});

export default withStyles(diStyles)(DescriptionItem);



// WEBPACK FOOTER //
// ./src/shared/DescriptionItem.js